import './index.scss'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, Toast, Space } from 'antd-mobile'
import { LockOutline, UserOutline } from 'antd-mobile-icons'
import { useState, useEffect } from 'react'

import { login } from '../../api/auth'
import { appSlice } from '../../store/app'
import { cacheKeys } from '../../utils/constant'
import { get, set } from '../../utils/storage'
import md5 from 'md5';

export default function Login() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [form] = Form.useForm();

  // 组件加载时检查是否有保存的登录信息
  useEffect(() => {
    console.log("手机号码：" + get(cacheKeys.loginPhone))
    let password = get(cacheKeys.loginPassword) || ''
    if (password !== '') {
      password = '********'
    }

    form.setFieldsValue({
      phone: get(cacheKeys.loginPhone) || '',
      password: password,
    });
  }, [form]);

  return (
    <div className="login flex-align-center flex-column">
      <h2>请先登录</h2>
      <Form
        form={form}
        layout="horizontal"
        onFinish={values => {
          setLoading(true)
          let password = ""
          if (values.password === '********') {
            password = get(cacheKeys.loginPassword) || ''
          } else {
            password = md5(values.password)
          }

          ;(
            login({
              phone: values.phone,
              password: password
            }) as unknown as Promise<{ code: number; msg?: string; data?: unknown }>
          ).then(res => {
              console.log(res)
              if (res.code !== 200) {
                setLoading(false)
                Toast.show({
                  icon: 'fail',
                  content: res.msg || '登录失败，请重试'
                })
                return
              }
              dispatch(appSlice.actions.login(res.data))
              // 缓存账号密码
              set(cacheKeys.loginPhone, values.phone, 3600 * 24 * 365 * 1000)
              set(cacheKeys.loginPassword, password, 3600 * 24 * 365 * 1000)

              Toast.show({
                icon: 'success',
                content: '登录成功'
              })
              setLoading(false)
              setTimeout(() => {
                navigate('/')
              }, 1100)
            })
            .catch(err => {
              setLoading(false)
              Toast.show({
                icon: 'fail',
                content: err.msg || '登录失败，请重试'
              })
            })
        }}
        className="form"
        footer={
          <Button block shape="rounded" type="submit" color="primary" size="large" loading={loading}>
            登陆系统
          </Button>
        }
      >
        <Form.Item
          name="phone"
          label={
            <Space>
              <UserOutline />
              <span>手机号</span>
            </Space>
          }
          rules={[{ required: true, message: '用户名不能为空' }]}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item>
        <Form.Item
          name="password"
          label={
            <Space>
              <LockOutline />
              <span>密码</span>
            </Space>
          }
          rules={[{ required: true, message: '密码不能为空' }]}
        >
          <Input placeholder="请输入密码" type="password" />
        </Form.Item>
      </Form>
    </div >
  )
}
